import { ReactElement } from 'react';

import { useStoreState } from '~/store/hooks';
import QuickNotes from './QuickNotes';

import styles from './PatientPanel.module.scss';
import { isoToFormat } from '~/utils/date';
import { Timezone } from '~/types';

const PatientPanel = (): ReactElement => {
  const patient = useStoreState(state => state.patient.info);

  if (!patient) return null;

  return (
    <div className={styles.patientPanel}>
      <div>
        <span className={styles.title}>Program:</span> {patient.programName}
      </div>
      <div className={styles.divider} />
      <QuickNotes patientId={patient.id} />
      <div>
        <span className={styles.title}>Patient:</span> {patient.fullName}
      </div>
      <div className={styles.divider} />
      <div>
        <span className={styles.title}>DOB:</span>{' '}
        {isoToFormat(patient.dateOfBirth, 'dd MMM y', Timezone.GMT, false)}
      </div>
    </div>
  );
};

export default PatientPanel;
